module.exports = __webpack_public_path__ + "img/commodities2_blue.b2f4212d.svg";